import convertByOffset from './convert-by-offset';
export default convertByOffset;
